import { convertMoneyToMinorUnits, formatMoney } from '@theme/money-formatting';

class ExpressCheckout extends HTMLElement {

    constructor() {
        super();

        this.button = null;
        this.loader = null;

        this.variantId = null;
        this.quantity = 1;

        this.loading = false;
    }

    connectedCallback() {

        this.button = this.querySelector('button');
        this.loader = this.querySelector('.express-checkout__loader');

        // this.variantId = Number(this.dataset.variantId);
        this.quantity = Number(this.dataset.quantity || 1);

        this.button?.addEventListener(
            'click',
            this.handleClick.bind(this)
        );

    }

    async handleClick() {

        if (this.loading) {
            return;
        }

        this.variantId = document.querySelector(".shopify-product-form [name=id]").value;

        if (!this.variantId) {
            console.error('Variant ID is missing.');
            return;
        }

        this.setLoading(true);

        try {

            // await this.clearCart();

            await this.addToCart();

            window.location.assign('/checkout');

        } catch (error) {

            console.error(error);

            alert(
                error.description ||
                error.message ||
                'Unable to checkout.'
            );

            this.setLoading(false);

        }

    }

    async clearCart() {

        await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                Accept: 'application/json'
            }
        });

    }

    async addToCart() {

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: this.variantId,
                    quantity: this.quantity
                }]
            })
        });

        if (!response.ok) {
            throw await response.json();
        }

        return response.json();

    }

    setLoading(state) {

        this.loading = state;

        this.button.disabled = state;

        this.loader.classList.toggle(
            'hidden',
            !state
        );

        this.button
            .querySelector('.express-checkout__text')
            ?.classList.toggle(
                'hidden',
                state
            );

    }

}

customElements.define(
    'express-checkout',
    ExpressCheckout
);

class KitItem extends HTMLElement {
    constructor() {
        super();

        this.variantTitle = null;

        this.variantSelector = this.querySelector(".kit-item-selector");

        this.price = this.querySelector(".kit-item-price");

        this.atcInput = this.querySelector(".upgrade-kit-id");

        this.atc = this.querySelector(".add-upgrade-kit");

        this.loading = false;

        this.loader = this.querySelector(".kit-loader");

        this.kitSwatches = this.querySelectorAll(".kit-item-color");

        this.kitTitle = this.querySelector(".kit-item-title");

        this.kitImage = this.querySelector(".kit-item-image");

        this.colorLabel = this.querySelector(".selected-color-label");

    }

    connectedCallback(){
        document.addEventListener("variant:update",(e) => { this.onVariantUpdate(e.detail) });
        this.variantSelector.addEventListener("change",this.onKitVariantChange.bind(this));
        this.atc.addEventListener("click",this.handleATC.bind(this));

        this.kitSwatches.forEach((kitSwatch) => {
            kitSwatch.addEventListener("click",(swatch) => {
                this.updateColorProduct(swatch)
            });
        });
    }

    onVariantUpdate(detail){
        this.variantTitle = detail?.resource?.title;

        if(this.variantTitle)
        {
            const selectedId = this.variantSelector.querySelector("option[data-title='"+this.variantTitle+"']").value;
            const selectedPrice = this.variantSelector.querySelector("option[data-title='"+this.variantTitle+"']").getAttribute("data-price");
            this.variantSelector.value = selectedId;
            this.price.innerHTML = selectedPrice;
            this.variantSelector.dispatchEvent(new Event('change'));
        }
    }

    onKitVariantChange(){
        this.atcInput.value = this.variantSelector.value;
    }

    async handleATC(){
        if (this.loading) {
            return;
        }

        this.setLoading(true);

        try {

            await this.addToCart();

            window.location.assign('/cart');

        } catch (error) {

            console.error(error);

            alert(
                error.description ||
                error.message ||
                'Unable to add to cart.'
            );

            this.setLoading(false);

        }

    }

    setLoading(state) {

        this.loading = state;

        this.atc.disabled = state;

        this.loader.classList.toggle(
            'hidden',
            !state
        );

        this.atc
            .querySelector('.kit-add-text')
            ?.classList.toggle(
                'hidden',
                state
            );

    }

    async addToCart() {

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: this.atcInput.value,
                    quantity: 1
                }]
            })
        });

        if (!response.ok) {
            throw await response.json();
        }

        return response.json();

    }

    updateColorProduct(swatch){
        if(swatch.target.classList.contains("active"))
        {
            return;
        }

        const productHandle = swatch.target.getAttribute("data-handle");

        const productJSON = kit_colors[productHandle];

        if(productJSON)
        {
            const title = productJSON.title;
            const image = productJSON.image;
            const variants = JSON.parse(productJSON.variants);

            const variantOptions = variants.map(variant => {
                return `<option value="${variant.id}" data-title="${variant.title}" data-price="${formatMoney(variant.price,"${{amount}}",Shopify.currency.active)}">${variant.title}</option>`;
            }).join('');

            swatch.target.closest(".kit-item-swatch").querySelector(".active").classList.remove("active");

            swatch.target.classList.add("active");

            this.colorLabel.innerHTML = productJSON.colorLabel;

            this.kitTitle.innerHTML = title;

            this.kitImage.innerHTML = image;

            this.variantSelector.innerHTML = variantOptions;

            if(this.variantTitle)
            {
                const selectedId = this.variantSelector.querySelector("option[data-title='"+this.variantTitle+"']").value;
                const selectedPrice = this.variantSelector.querySelector("option[data-title='"+this.variantTitle+"']").getAttribute("data-price");
                this.variantSelector.value = selectedId;
                this.price.innerHTML = selectedPrice;
                this.variantSelector.dispatchEvent(new Event('change'));
            }
        }

        

    }


}

customElements.define('kit-item',KitItem);


class BundleColor extends HTMLElement{
    constructor(){
        super();
    }

    connectedCallback(){
        document.addEventListener("set:update",(e)=>{
            this.createColorOption(e);
        });
    }

    createColorOption(e){
        const bundleSet = e.detail.set;

        const bundleOption = bundleData[bundleSet];

        const bundleForm = document.querySelector("bundle-form");

        const activeProduct = bundleForm.querySelector(".set-items[data-handle='"+bundleSet+"']").querySelector("input:checked").value;

        const activeColor = bundleForm.querySelector(".set-items[data-handle='"+bundleSet+"']").querySelector("input:checked").getAttribute("data-color");

        const bundleColors = bundleOption[activeProduct]["colors"];

        const colorHTML = []

        for(const color in bundleColors){
           colorHTML.push(`
                <div class="bundle-color-item ${(activeColor == color)?"active":""}">
                <span class="bundle-color" data-handle="${bundleSet}" data-label="${bundleColors[color].colorLabel}" style="background-color:${bundleColors[color].color}">
                </span>
                </div>
            `);
        }

        this.innerHTML = `
            <div class="bundle-color-swatch">
                <div class="bundle-color-inner">
                    <div class="bundle-color-heading">
                        Colour : <span class="selected-label">${activeColor}</span>
                    </div>
                    <div class="bundle-color-items">
                        ${colorHTML.join('')}
                    </div>
                </div>
            </div>
        `;

        this.handleClickEvent();

    }

    handleClickEvent(){
        const colorSwatches = this.querySelectorAll(".bundle-color-item");

        const _this = this;

        colorSwatches.forEach((color)=>{
            color.addEventListener("click", ()=>{

                if(color.classList.contains("active"))
                {
                    return;
                }

                color.closest(".bundle-color-items").querySelector(".active").classList.remove("active");

                color.classList.add("active");

                const activeMaterial = color.querySelector(".bundle-color").getAttribute("data-handle");

                const colorValue = color.querySelector(".bundle-color").getAttribute("data-label");

                _this.querySelector(".selected-label").innerHTML = colorValue;

                const materials = bundleData[activeMaterial];

                const newSetData = {};

                for(const material in materials)
                {
                    const availColors = materials[material]?.colors[colorValue];
                    if(availColors)
                    {
                        const newColorTitle = availColors.title;
                        const newColorImage = availColors.image;
                        const newColorHandle = availColors.handle;
                        const newColorVariants = JSON.parse(availColors.variants);
                        const newColorOptions = newColorVariants.map(variant=>{
                            return `<option value="${variant.id}" data-title="${variant.title}" data-price="${variant.price}">${variant.title}</option>`;
                        }).join(""); 
                        newSetData[material] = {
                            "hasColor": true,
                            "title": newColorTitle,
                            "image": newColorImage,
                            "handle": newColorHandle,
                            "color": colorValue,
                            "options":newColorOptions
                        }
                    }
                    else
                    {
                        newSetData[material] = {
                            "hasColor":false
                        };
                    }
                }

                this.dispatchEvent(new CustomEvent('change:setColor',{
                        bubbles: true,
                        detail:newSetData
                    })
                );
            });
            
        });
    }
}

customElements.define('bundle-color',BundleColor);

class BundlePrice extends HTMLElement{
    constructor(){
        super()

    }

    connectedCallback(){
        this.updatePrice();

        document.addEventListener("change:setItem",()=>{
            this.updatePrice()
        });
    }

    updatePrice(){
        const activeMaterial = document.querySelector(".material-item.active").getAttribute("data-handle");
        const selectProducts = document.querySelectorAll(".set-items[data-handle='"+activeMaterial+"'] .set-item");

        let price = 0;
        let discountPrice = 0;
        let checkedCount = 0;

        selectProducts.forEach((product)=>{
            const input = product.querySelector("input");
            if(input.checked)
            {
                checkedCount++;
                const vid =  product.querySelector("select").value;
                const vprice = product.querySelector("select option[value='"+vid+"']").getAttribute("data-price");
                price += parseFloat(vprice);
            }
        });

        if(checkedCount >= 2){
            if(checkedCount == 2)
            {
                discountPrice += price - (price/10) ;
            }
            else
            {
                discountPrice += price - (price/20) ;
            }
        }

        if(discountPrice != 0)
        {
            document.querySelector(".bundle-atc-price").innerHTML = formatMoney(discountPrice,"${{amount}}",Shopify.currency.active);
        }
        else
        {
            document.querySelector(".bundle-atc-price").innerHTML = formatMoney(price,"${{amount}}",Shopify.currency.active);
        }
       

        this.innerHTML = `
            <div class="bundle-price">
                ${
                    (checkedCount >= 2)?
                    `
                        <span class="bundle-actual-price">
                            ${
                                formatMoney(discountPrice,"${{amount}}",Shopify.currency.active)
                            }
                        </span>
                        <span class="bundle-compare-price">
                            ${formatMoney(price,"${{amount}}",Shopify.currency.active)}
                        </span>
                    `
                    : `
                        <span class="bundle-actual-price">
                            ${formatMoney(price,"${{amount}}",Shopify.currency.active)}
                        </span>
                    `
                }
                ${
                    (checkedCount >= 2)?
                    `
                        <span class="bundle-discount">
                            You're saving ${(checkedCount == 2)?formatMoney(price/10,"${{amount}}",Shopify.currency.active)+" (10%)":
                                formatMoney(price/20,"${{amount}}",Shopify.currency.active)+" (20%)"
                            }
                        </span>
                    `
                    :""
                }
            </div>
        `;
    }
}

customElements.define('bundle-price',BundlePrice);

class BundleSize extends HTMLElement{
    constructor(){
        super();

    }

    connectedCallback(){
        document.addEventListener("set:update",(e)=>{
            this.createSizeOption(e);
        });

        document.addEventListener("updated:setColor",(e)=>{
            this.updateSelectorInSet();
        });
    }

    createSizeOption(e){
        const bundleSet = e.detail.set;

        const bundleOption = bundleData[bundleSet];

        const bundleForm = document.querySelector("bundle-form");

        const activeProduct = bundleForm.querySelector(".set-items[data-handle='"+bundleSet+"']").querySelector("input:checked").value;

        const bundleSizes = JSON.parse(bundleOption[activeProduct]["variants"]);

        const sizeHTML = bundleSizes.map((variant,index)=>{
            return `
                <div class="bundle-size-item">
                    <label class="size-label">
                        <input type="radio" name="size-option" value="${variant.title}" data-handle=${bundleSet} ${(index==0)?"checked":""}>
                        <span class="size-text">${variant.title}</span>
                    </label>
                </div>
            `;
        }).join(""); 

        this.innerHTML = `
            <div class="bundle-size-swatch">
                <div class="bundle-size-inner">
                    <div class="bundle-size-heading">
                        Size
                    </div>
                    <div class="bundle-size-items">
                        ${sizeHTML}
                    </div>
                </div>
            </div>
        `;

        this.handleClickEvent();

    }

    handleClickEvent(){
       const sizeSwatches =  this.querySelectorAll(".bundle-size-items input");
       const _this = this;
       sizeSwatches.forEach((size)=>{
        size.addEventListener("change",function(){
            _this.updateSets(size);
        });
       })
    }

    updateSets(size){
        const sizeValue = size.value;
        const activeMaterial = size.getAttribute("data-handle");
        const selectProducts = document.querySelectorAll(".set-items[data-handle='"+activeMaterial+"'] .set-item");

        selectProducts.forEach((product)=>{
            const selector = product.querySelector(".set-variant");
            const vid = product.querySelector(".set-variant option[data-title='"+sizeValue+"']").value;
            const vprice = product.querySelector(".set-variant option[data-title='"+sizeValue+"']").getAttribute("data-price");
            selector.value = vid;
            product.querySelector(".prod-price").innerHTML = formatMoney(vprice,"${{amount}}",Shopify.currency.active);
        });

        this.dispatchEvent(new CustomEvent('change:setItem',{
                bubbles: true
            })
        );
    }

    updateSelectorInSet(){
        const size = this.querySelector(".bundle-size-item input:checked");
        this.updateSets(size);
    }


}
customElements.define('bundle-size',BundleSize);


class BundleForm extends HTMLElement{
    constructor() {
        super();

        this.currentMaterial = null;

        this.selectedMaterial = this.querySelector(".selected-material");

        this.materialItems = this.querySelectorAll(".material-item");

        this.setItems = this.querySelectorAll(".set-item input");

    }

    connectedCallback(){

        this.initSet();

        this.materialItems.forEach((item)=>{
            item.addEventListener("click",()=>{
                this.showBundleSet(item);
            });
        });

        this.setItems.forEach((item)=>{
            item.addEventListener("change",this.changeSetItem.bind(this));
        });

        document.addEventListener("change:setColor",(e)=>{
            this.changeSetColor(e.detail);
        });

    }

    showBundleSet(e){
        if(e.classList.contains("active"))
        {
            return;
        }

        const setHandle = e.getAttribute("data-handle");

        this.querySelector(".material-item.active").classList.remove("active");

        e.classList.add("active");

        this.querySelectorAll(".set-items").forEach((set)=>{
            set.classList.add("hidden");
        });

        this.currentMaterial = setHandle;
        this.querySelector(".set-items[data-handle='"+setHandle+"']").classList.remove("hidden");
        this.dispatchUpdate(setHandle);
        this.changeSetItem();
        this.updateMediaGallery(setHandle);
    }

    initSet(){
        const activeMaterial = this.querySelector(".material-item.active");
        const setHandle = activeMaterial.getAttribute("data-handle");
        this.currentMaterial = setHandle;
        this.querySelector(".set-items[data-handle='"+setHandle+"']").classList.remove("hidden");
        this.dispatchUpdate(setHandle);

        this.updateMediaGallery(setHandle);
    }

    changeSetColor(detail){
        console.log(detail);
        const activeMaterialSet = this.querySelector(".set-items[data-handle='"+this.currentMaterial+"']");
        for(const setItem in detail)
        {
            const item = detail[setItem];
            if(item.hasColor)
            {
                const { title, image, color, handle, options } = item;
                const set = activeMaterialSet.querySelector(".set-item[data-handle='"+setItem+"']");
                set.classList.remove("disabled");
                set.querySelector("input").setAttribute("data-color",color);
                set.querySelector("input").value = handle;
                set.querySelector(".set-variant").innerHTML = options;
                set.querySelector(".prod-title").innerHTML = title;
                set.querySelector(".prod-image").innerHTML = image;

            }
            else
            {
                activeMaterialSet.querySelector(".set-item[data-handle='"+setItem+"']").classList.add("disabled");
            }
        }

        this.dispatchEvent(new CustomEvent('updated:setColor',{
                bubbles: true
            })
        );
    }

    updateMediaGallery(setHandle){
        const mediaGallery = document.querySelector(".media-gallery__grid");
        const galleryItems = mediaGallery.querySelectorAll(".product-media-container--image");

        const galleryItemsMobile = document.querySelectorAll("slideshow-container .product-media");

        const gallerySliderDot = document.querySelectorAll(".slideshow-controls__dots li");

        galleryItems.forEach((item)=>{
            item.classList.add("hidden");
        });

        const activeGalleryItems = mediaGallery.querySelectorAll(".product-media-container--image[data-alt='"+setHandle+"']");

        const activeGalleryItemsMobile = document.querySelectorAll("slideshow-container .product-media[data-alt='"+setHandle+"']");

        activeGalleryItems.forEach((item)=>{
            item.classList.remove("hidden");
        });

        galleryItemsMobile.forEach((item,index)=>{
            item.closest("slideshow-slide").classList.add("hidden");
            item.closest("slideshow-slide").setAttribute("data-index",index);
        });

        gallerySliderDot.forEach((dot,index)=>{
            dot.classList.add("hidden");
            dot.querySelector("button").setAttribute("aria-selected","false");
            dot.setAttribute("data-index",index);
        });

        activeGalleryItemsMobile.forEach((item,index)=>{
            item.closest("slideshow-slide").classList.remove("hidden");
            const indx = item.closest("slideshow-slide").getAttribute("data-index");
            if(index == 0)
            {
               document.querySelector(".slideshow-controls__dots li[data-index='"+indx+"']").querySelector("button").setAttribute("aria-selected","true");
            }
            document.querySelector(".slideshow-controls__dots li[data-index='"+indx+"']").classList.remove("hidden");
        });
 

    }

    changeSetItem(){
        this.dispatchEvent(new CustomEvent('change:setItem',{
                bubbles: true
            })
        );
    }

    dispatchUpdate(handle){
        this.dispatchEvent(new CustomEvent('set:update',{
                bubbles: true,
                detail: { 
                    set:handle
                }
            })
        );
    }
}

customElements.define('bundle-form',BundleForm);


class BundleBuy extends HTMLElement{
    constructor(){
        super()

        this.expressCheckout = this.querySelector(".express-checkout__button");

        this.atcButton = this.querySelector(".atc__button");

        this.selectedVariants = [];
    }

    connectedCallback(){
        this.expressCheckout.addEventListener("click",this.handleExpressClick.bind(this));

        this.atcButton.addEventListener("click",this.handleAtcClcik.bind(this));

    }

    async handleExpressClick(){
        const bundleForm = document.querySelector("bundle-form");

        const { currentMaterial } = bundleForm;

        const selectedSetItems = bundleForm.querySelector(".set-items[data-handle='"+currentMaterial+"']");

        selectedSetItems.querySelectorAll(".set-item").forEach((set)=>{
            if(!set.classList.contains("disabled"))
            {
                const input = set.querySelector("input");
                if(input.checked)
                {
                    const selector = set.querySelector(".set-variant")
                    this.selectedVariants.push(selector.value);
                }
                
            }
        });

        if(this.selectedVariants == '')
        {
            alert("Select atleast one Item");
            return;
        }

        this.expressCheckout.querySelector(".express-checkout__text").classList.add("hidden");
        this.expressCheckout.querySelector(".express-checkout__loader").classList.remove("hidden");

        try {

            await this.addToCart();

            window.location.assign('/checkout');

        } catch (error) {

            console.error(error);

            alert(
                error.description ||
                error.message ||
                'Unable to checkout.'
            );

            this.expressCheckout.querySelector(".express-checkout__text").classList.remove("hidden");
            this.expressCheckout.querySelector(".express-checkout__loader").classList.add("hidden");

        }

    }

    async handleAtcClcik(){
        const bundleForm = document.querySelector("bundle-form");

        const { currentMaterial } = bundleForm;

        const selectedSetItems = bundleForm.querySelector(".set-items[data-handle='"+currentMaterial+"']");

        selectedSetItems.querySelectorAll(".set-item").forEach((set)=>{
            if(!set.classList.contains("disabled"))
            {
                const input = set.querySelector("input");
                if(input.checked)
                {
                    const selector = set.querySelector(".set-variant")
                    this.selectedVariants.push(selector.value);
                }
                
            }
        });

        if(this.selectedVariants == '')
        {
            alert("Select atleast one Item");
            return;
        }

        this.atcButton.querySelector(".atc__text").classList.add("hidden");
        this.atcButton.querySelector(".atc__loader").classList.remove("hidden");

        try {

            const drawer = document.querySelector("cart-drawer-component");

            const headerID = drawer.querySelector("cart-items-component").getAttribute("data-section-id"); 

            const response =  await this.addToCart(headerID);

            const header = response.sections[headerID];

            const parser = new DOMParser();

            const doc = parser.parseFromString(header, 'text/html');

            const newCartData = doc.querySelector("[data-hydration-key='cart-drawer-inner']").innerHTML;

            document.querySelector("[data-hydration-key='cart-drawer-inner']").innerHTML = newCartData;
            
            drawer.open();

            this.atcButton.querySelector(".atc__text").classList.remove("hidden");
            this.atcButton.querySelector(".atc__loader").classList.add("hidden");

            // window.location.assign('/checkout');

        } catch (error) {

            console.error(error);

            alert(
                error.description ||
                error.message ||
                'Unable to checkout.'
            );

            this.atcButton.querySelector(".atc__text").classList.remove("hidden");
            this.atcButton.querySelector(".atc__loader").classList.add("hidden");

        }

    }

    async addToCart(section = ''){

        const items = this.selectedVariants.map((variant,index)=>(
            (index > 0)
                ?
                {

                
                    id:variant,
                    quantity:1,
                    parent_id:this.selectedVariants[0]
                }
                :
                {
                    id:variant,
                    quantity:1
                }
                    
        ));

        const response = await fetch('/cart/add.js?sections='+section, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                items: items
            })
        });

        if (!response.ok) {
            throw await response.json();
        }

        this.selectedVariants = [];

        return response.json();
    }
}

customElements.define("bundle-buy",BundleBuy);


class CartSlider extends HTMLElement{
    constructor(){
        super()

        this.currentIndex = 0;

        this.timer = null;

        this.isHovered = false;

        this.handleNext = this.next.bind(this);

        this.handlePrevious = this.previous.bind(this);

        this.handleMouseEnter = this.pause.bind(this);

        this.handleMouseLeave = this.resume.bind(this);

    }

    connectedCallback(){

        this.track = this.querySelector(".cart_slider__track");

        this.nextButton = this.querySelector(".cart_slider__next");

        this.prevButton = this.querySelector(".cart_slider__prev");

        if(!this.track)
        {
            return;
        }

        this.interval = Number(this.dataset.interval) || 5000 ;

        this.autoplay = (this.dataset.autoplay == "true")? true : false;

        this.addEvents();

        this.update();

        if(this.autoplay == true)
        {
            this.start();
        }
        
    }

    disconnectedCallback() {

        this.stop();

        this.removeEvents();
    }


    addEvents(){

        this.nextButton?.addEventListener('click',this.handleNext);

        this.prevButton?.addEventListener('click',this.handlePrevious);

        this.addEventListener('mouseenter',this.handleMouseEnter);

        this.addEventListener('mouseleave',this.handleMouseLeave);

    }

    removeEvents() {

        this.nextButton?.removeEventListener('click',this.handleNext);

        this.prevButton?.removeEventListener('click',this.handlePrevious);

        this.removeEventListener('mouseenter',this.handleMouseEnter);

        this.removeEventListener('mouseleave',this.handleMouseLeave);
    }

    next() {

        this.slides = [...this.querySelectorAll("cart-slide")];

        this.currentIndex++;

        if (this.currentIndex >= this.slides.length) {
        this.currentIndex = 0;
        }

        this.update();

        this.restart();
    }

    previous() {

        this.slides = [...this.querySelectorAll("cart-slide")];

        this.currentIndex--;

        if (this.currentIndex < 0) {
        this.currentIndex = this.slides.length - 1;
        }

        this.update();

        this.restart();
    }

    update() {

        const offset =
        this.currentIndex * 100;

        this.track.style.transform =
        `translate3d(-${offset}%, 0, 0)`;
    }

    start() {

        this.stop();

        this.timer = setInterval(this.handleNext,this.interval);
    }

    stop() {

        if (!this.timer) {
        return;
        }

        clearInterval(this.timer);

        this.timer = null;
    }

    restart() {

        if (this.isHovered || !this.autoplay) {
        return;
        }

        this.start();
    }

    pause() {

        this.isHovered = true;

        this.stop();
    }

    resume() {

        this.isHovered = false;

        if(!this.autoplay)
        {
            return;
        }

        this.start();
    }

}

customElements.define("cart-slider",CartSlider);

class CartSlide extends HTMLElement{
    constructor(){
        super()

        this.atc = this.querySelector(".cart-set-atc");

        this.variantId = this.querySelector(".cart-set-id").dataset.id;

    }

    connectedCallback(){

        this.atc.addEventListener("click",this.handlATCEvent.bind(this))

    }

    async handlATCEvent(){
        try {

            this.atc.classList.add("disabled");

            const drawer = document.querySelector("cart-drawer-component");

            const headerID = drawer.querySelector("cart-items-component").getAttribute("data-section-id"); 

            const response = await this.addToCart(headerID);

            const header = response.sections[headerID];

            const parser = new DOMParser();

            const doc = parser.parseFromString(header, 'text/html');

            const newCartData = doc.querySelector("[data-hydration-key='cart-drawer-inner']").innerHTML;

            document.querySelector("[data-hydration-key='cart-drawer-inner']").innerHTML = newCartData;
            

        } catch (error) {

            console.error(error);

            alert(
                error.description ||
                error.message ||
                'Unable to checkout.'
            );

            this.atc.classList.remove("disabled");

        }
    }

    async addToCart(section){
        const response = await fetch('/cart/add.js?sections='+section, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: this.variantId,
                    quantity: 1
                }]
            })
        });

        if (!response.ok) {
            throw await response.json();
        }

        return response.json();
    }
}

customElements.define("cart-slide",CartSlide)


const card_swatch = document?.querySelectorAll(".card-item-swatch");

if(card_swatch.length != 0)
{
    card_swatch.forEach((swatch)=>{

        const swatch_items = swatch.querySelectorAll("a");

        swatch_items.forEach((swatch_item)=>{

            swatch_item.addEventListener("click",()=>{

                swatch.querySelector(".active").classList.remove("active");

                swatch_item.querySelector(".card-item-color").classList.add("active");
            });
        });
        

    });
}

const related_color = document?.querySelectorAll(".related-color-item");

if(related_color.length != 0)
{
    related_color.forEach((color)=>{
        color.addEventListener("click",()=>{
            color.closest(".related-color-items").querySelector(".color-link.active").classList.remove("active");

            color.querySelector("a").classList.add("active");
        });
    });
}